import React, { useEffect, useMemo, useState } from "react";
import SelectComponent from "../../../components/Tenant/SelectComponent/SelectComponent";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import InputComponent from "../../../components/Tenant/InputComponent/InputComponent";
import {
  useFetchProductsMutation,
  useUpdateProductByProductIdMutation,
  useFetchProductPrinterSettingsMutation,
  useUpdateProductPrinterSettingsMutation,
} from "../../../features/tenant/products/productsApi";
import { toast } from "react-hot-toast";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import { useLocation, useNavigate } from "react-router-dom";
import { useFetchSubcategoriesMutation } from "../../../features/tenant/productHeirarchy/productHeirarchyApi";
import { useFetchAllBrandsMutation } from "../../../features/tenant/brands/brandsApi";
import { useFetchUomKeysMutation } from "../../../features/admin/uomKeys/uomKeysApi";
import SelectComponentWithSearch from "../../../components/Tenant/SelectComponentWIthSearch/SelectComponentWithSearch";
import { getVendorName } from "../../../utils/getVendorName";
import { useUploadSingleFileMutation } from "../../../features/admin/imageUpload/imageUploadApi";
import TenantSlugs from "../../../utils/TenantSlug";

const productEarningType = [
  {
    id: "1",
    name: "Low"
  },
  {
    id: "2",
    name: "High"
  }
]

const productQRType = {
  normal: 1,
  complex: 2,
};

const productStatus = [
  {
    id: "1",
    name: "active",
    avatar:
      "https://images.unsplash.com/photo-1491528323818-fdd1faba62cc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  },
  {
    id: "2",
    name: "inactive",
    avatar:
      "https://images.unsplash.com/photo-1491528323818-fdd1faba62cc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  }
];

const productUnits = [
  {
    id: "1",
    name: "box",
  },
  {
    id: "2",
    name: "pieces",
  },
];


const EditProduct = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [
    fetchSubCategories,
    { data: subCategoriesData, error: subCategoriesError },
  ] = useFetchSubcategoriesMutation();
  const [fetchBrandList, { data: brandsData, error: brandsError }] =
    useFetchAllBrandsMutation();

  const {
    state: { product },
  } = location;
  // console.log("location", product);

  const [selectedProductCategory, setSelectedProductCategory] = useState([]);

  const [selectedProductStatus, setSelectedProductStatus] = useState(() =>
    productStatus.find((stat) => Number(stat.id) === Number(product.status)),
  );

  const [selectedProductUnit, setSelectedProductUnit] = useState(() =>
    productUnits.find(
      (prodUnit) => Number(prodUnit.id) === Number(product.unit_id),
    ),
  );

  const [selectedBrandName, setSelectedBrandName] = useState([]);

  const [
    fetchUomKeys,
    { data: uomKeysData, isLoading: uomKeysisLoading, error: uomKeysError },
  ] = useFetchUomKeysMutation();

  const [selectedUomKey, setSelectedUomKey] = useState({
    id: -1,
    name: "",
  });

  const isBorosilTenant =
      JSON.parse(sessionStorage.getItem("vendorData")).tenant_id ==
      TenantSlugs.borosil;

  const isVoxTenant = getVendorName()?.toLowerCase() === "vox";

  const [uomValue, setUomValue] = useState(null);
  const [earningType, setEarningType] = useState(
      isBorosilTenant
          ? productEarningType.filter(
                (item) => product?.more_details?.rank == item.id
            )[0]
          : null
  );

  useEffect(() => {
    fetchSubCategories({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
    });
    fetchUomKeys({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
    });
  }, []);

  useEffect(() => {
    fetchBrandList({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
    });
  }, []);

  useEffect(() => {
    if (uomKeysData) {
      console.log("uom keys data", uomKeysData);
      if (uomKeysData.body) {
        setSelectedUomKey(
          uomKeysData.body.find((each) => each.name == product.uom_key),
        );
      }
      setUomValue(product.uom_value);
    }
    if (uomKeysError) {
      console.log("uom keys errror", uomKeysError);
    }
  }, [uomKeysData, uomKeysError]);

  useEffect(() => {
    if (subCategoriesData) {
      console.log("SubCAtegories", subCategoriesData);
      if (subCategoriesData.body) {
        setSelectedProductCategory(
          subCategoriesData.body.find(
            (prod) => Number(prod.id) === Number(product.category_id),
          ),
        );
      }

    }

    if (brandsData?.body?.brands?.length) {
      console.log("brandss", brandsData);
      setSelectedBrandName(
        brandsData?.body?.brands?.find(
          (x) => Number(x.id) === Number(product.brand_id),
        ),
      );
    }
  }, [subCategoriesData, subCategoriesError, brandsData, brandsError]);


  const [
    updateProductByProductId,
    {
      data: updateProductData,
      isLoading: updateProductIsLoading,
      isError: updateProductIsError,
      error: updateProductError,
    },
  ] = useUpdateProductByProductIdMutation() || {};

  const [fetchProducts, { data: productData }] = useFetchProductsMutation();

  const [productCode, setProductCode] = useState(product.product_code);
  const [productName, setProductName] = useState(product.name);
  const [productDes, setProductDes] = useState(product.description);
  const [video, setVideo] = useState(product?.video);
  const [qty, setQty] = useState(product.qty);
  const [mrp, setMrp] = useState(product.mrp);
  const [wsp, setWsp] = useState(product.wsp);
  const [bsp, setBsp] = useState(product.bsp);
  const [images, setImages] = useState(
    (product?.images && product.images[0]) ||
    `/default-image.jpg`,
  );


  const [color, setColor] = useState(product.color);
  const [size, setSize] = useState(product.size);
  const [classification, setClassification] = useState(product.classification);
  const [barcode, setBarcode] = useState(product?.barcode || "");

  // Printer settings logic
  const [showPrinterModal, setShowPrinterModal] = useState(false);
  const [printerSettings, setPrinterSettings] = useState({
    pieces: '', rft: '', rftUnit: 'meter', lengthVal: '', lengthUnit: 'sqm', length: '',
    qCode: '', packerCode: '',
    nominalQty: '', nominalWidth: '', nominalHeight: '', netWeight: '', grossWeight: '',
    barcodeNumber: '',
    linProductName: '', linProductCode: '', linMrp: '', linOpr: '', linQ: '', linPacker: '',
    linSizeWidth: '', linSizeHeight: '', linCoverage: '', linCoverageUnit: 'Sqft', linPieces: '',
    linNetWeight: '', linGrossWeight: '', linBarcode: '',
    productCode: '', productColor: '', productCategoryName: '', categoryName: '', mrp: '',
    templateType: 'vox_label.prn', batchNo: ''
  });

  const [fetchPrinterSettings] = useFetchProductPrinterSettingsMutation();
  const [updatePrinterSettings, { isLoading: isUpdatingPrinterSettings }] = useUpdateProductPrinterSettingsMutation();

  const handleOpenPrinterSettings = async (e) => {
    e.preventDefault();
    setShowPrinterModal(true);

    const initialSettings = {
      productCode: productCode || "",
      productColor: color || "",
      categoryName: selectedProductCategory?.name || "",
      mrp: mrp || "",
      barcodeNumber: barcode || "",
      linProductName: productName || "",
      linProductCode: productCode || "",
      linMrp: mrp || "",
      linBarcode: barcode || "",
    };

    setPrinterSettings((prev) => ({ ...prev, ...initialSettings }));

    try {
      const res = await fetchPrinterSettings({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        product_code: product.product_code,
      }).unwrap();
      
      if (res?.body?.printer_settings) {
        setPrinterSettings((prev) => ({ ...prev, ...res.body.printer_settings }));
      }
    } catch (err) {
      console.log("Error fetching printer settings", err);
    }
  };

  const handleSavePrinterSettings = async (e) => {
    e.preventDefault();
    try {
      await updatePrinterSettings({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        body: {
          product_code: product.product_code,
          printer_settings: printerSettings
        }
      }).unwrap();
      toast.success("Printer settings saved successfully");
      setShowPrinterModal(false);
    } catch (err) {
      console.error(err);
      toast.error("Failed to save printer settings");
    }
  };


  const handleEditProduct = (e) => {
    e.preventDefault();
    // console.log("object", images, formImg);

    const formData = new FormData();
    formData.append("image", images);
    formData.append("brand_id", Number(selectedBrandName.id));
    formData.append("brand_name", selectedBrandName.name);
    formData.append("product_code", productCode);
    formData.append("name", productName);
    formData.append("description", productDes);
    formData.append("unit_id", Number(selectedProductUnit?.id));
    formData.append("unit_name", selectedProductUnit?.name);
    formData.append("uom_key", selectedUomKey?.name);
    formData.append("uom_value", uomValue);
    formData.append("video", video);
    formData.append("size", size);
    formData.append("color", color);
    formData.append("video", video);
    formData.append("qty", qty);
    formData.append("mrp", mrp);
    formData.append("wsp", Number(wsp));
    formData.append("bsp", Number(bsp));
    formData.append("classification", classification);

    if (isVoxTenant) {
      formData.append("barcode", barcode);
    }

    formData.append(
      "qr_type",
      productQRType[Number(selectedProductUnit.id) === 1 ? "normal" : "complex"]
    );
    formData.append("status", selectedProductStatus.id);
    formData.append("category_id", Number(selectedProductCategory.id));
    formData.append("category_name", selectedProductCategory.name);

    // if (isBorosilTenant) {
    //   formData.append("rank", earningType?.id || earningType);
    // }

    const objectData = {};
    formData.forEach(function (value, key) {
      objectData[key] = value;
    });

    updateProductByProductId({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      product_id: product.product_id,
      body: objectData,
      // {
      //   brand_id: Number(selectedBrandName.id),
      //   brand_name: selectedBrandName.name,
      //   product_code: productCode,
      //   name: productName,
      //   description: productDes,
      //   unit_id: Number(selectedProductUnit.id),
      //   unit_name: selectedProductUnit.name,
      //   qty: qty,
      //   qr_type:
      //     productQRType[
      //       Number(selectedProductUnit.id) === 1 ? "normal" : "complex"
      //     ],
      //   images: images,
      //   status: selectedProductStatus.id,
      //   category_id: Number(selectedProductCategory.id),
      //   category_name: selectedProductCategory.name,
      // },
    });

    fetchProducts({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      limit: 10,
      offset: 0,
    });
  };

  if (updateProductIsError) {
    console.log("error fksdfalsfashfhfhnkklkhksdfhafk");
    // toast.dismiss();
    toast.error(`${updateProductError.data.message}`, {
      id: "add-product-error",
    });
  }

  if (updateProductIsLoading) {
    console.log("inside loading");
    // toast.dismiss();
    toast.loading("Updating Product...", {
      id: "add-product-loading",
    });
    if (productData) {
      console.log("inside");
    }
  }

  useEffect(() => {
    if (updateProductData) {
      toast.dismiss();
      toast.success("Product Updated Sucessfully", {
        id: "update-product-success",
      });

      setTimeout(() => {
        navigate(`/genefied/${getVendorName()}/product`);
      }, 1000);
    }
  }, [updateProductData]);

  useMemo(() => {
    if (productData && updateProductIsError === false) {
      console.log("use Memo");
      // toast.dismiss();
      // navigate("/genefied/baltra/product");
      // navigate(`/genefied/${getVendorName()}/product`)
    }
  }, [productData, updateProductIsError]);

  const [
    uploadImage,
    {
      data: uploadImageData,
      isLoading: uploadImageIsLoading,
      error: uploadImageError,
    },
  ] = useUploadSingleFileMutation();


  const previewImage = (event) => {
    const formData = new FormData();
    formData.append("image", event.target.files[0]);
    uploadImage({
      body: formData,
    });
    // setFormImg(event.target.files[0]);
    // const imageFiles = event.target.files;
    // const imageFilesLength = imageFiles.length;
    // if (imageFilesLength > 0) {
    //   const imageSrc = URL.createObjectURL(imageFiles[0]);
    //   setImages(imageSrc);
    // }
  };

  useEffect(() => {
    toast.dismiss();
    if (uploadImageData) {
      console.log("success image upload", uploadImageData.body);
      setImages(uploadImageData.body.fileLink);
    }
    if (uploadImageError) {
      toast.error("Image upload failed");
    }

    if (uploadImageIsLoading) {
      toast.loading("Uploading your image...", { id: "uploadImageLoading" });
    }
  }, [uploadImageData, uploadImageError, uploadImageIsLoading]);

  return (
    <div className="flex w-full bg-slate-200 h-full justify-center">
      <div className="w-full">
        <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
          Update Product
          <LinksComponent />
        </div>
        <div className="mx-4 mt-4 p-3 bg-white shadow rounded-lg">
          <form className="">
            <div>
              <div className="w-full flex justify-center items-end space-x-3 ">
                <div className="mb-6 w-1/3">
                    <SelectComponent
                      title={"Brand Name"}
                      selected={selectedBrandName}
                      setSelected={setSelectedBrandName}
                      dataArr={
                        brandsData && brandsData.body
                          ? brandsData.body.brands
                          : []
                      }
                    />
                </div>

                <div className="mb-6 w-1/3">
                    <SelectComponentWithSearch
                      title={"Category"}
                      selected={selectedProductCategory}
                      setSelected={setSelectedProductCategory}
                      dataArr={subCategoriesData ? subCategoriesData?.body : []}
                      withAvatar={true}
                    />
                </div>

                <div className="mb-6 w-1/3">
                    <InputComponent
                      name={"Product Name"}
                      type={"text"}
                      value={productName}
                      setValue={setProductName}
                      required={true}
                    />
                </div>
                <div className="mb-6 w-1/3">
                    <InputComponent
                      name={"Product Code"}
                      type={"text"}
                      value={productCode}
                      setValue={setProductCode}
                      required={true}
                      disabled={true}
                    />
                  </div>
              </div>

              <div className="w-full flex justify-center items-end space-x-3">
                <div className="mb-6 w-1/3">
                  <SelectComponent
                    title={"Packing"}
                    selected={selectedProductUnit}
                    setSelected={setSelectedProductUnit}
                    dataArr={productUnits}
                  />
                </div>

                <div className="mb-6 w-1/3">
                  <InputComponent
                    name={"Qty"}
                    type={"number"}
                    value={qty}
                    setValue={setQty}
                    required={true}
                  />
                </div>
                <div className="mb-6 w-1/3">
                  <InputComponent
                    name={"Classification"}
                    type={"text"}
                    value={classification}
                    setValue={setClassification}
                  />
                </div>
                <div className="mb-6 w-1/3">
                  <SelectComponent
                    title={"Status"}
                    selected={selectedProductStatus}
                    setSelected={setSelectedProductStatus}
                    dataArr={productStatus}
                  />
                </div>
              </div>

              <div className="w-full flex justify-center items-end space-x-2 mb-6">
                <div className="w-1/6">
                  <SelectComponentWithSearch
                    title={"Unit of Measurement"}
                    selected={selectedUomKey}
                    setSelected={setSelectedUomKey}
                    dataArr={uomKeysData ? uomKeysData?.body : []}
                  />
                </div>
                <div className="w-1/6">
                  <InputComponent
                    name={"Value"}
                    type={"text"}
                    value={uomValue}
                    setValue={setUomValue}
                  />
                </div>
                <div className="w-1/3">
                  <InputComponent
                    name={"Product Video Link"}
                    value={video}
                    setValue={setVideo}
                  />
                </div>
                <div className="w-1/3">
                  <InputComponent
                    name={"Colour"}
                    type={"text"}
                    value={color}
                    setValue={setColor}
                  />
                </div>
                <div className="w-1/3">
                  <InputComponent
                    name={"Size"}
                    type={"text"}
                    value={size}
                    setValue={setSize}
                  />
                </div>

                {isVoxTenant && (
                  <div className="w-1/3">
                    <InputComponent
                      name={"Barcode"}
                      type={"text"}
                      value={barcode}
                      setValue={setBarcode}
                    />
                  </div>
                )}

                {/* {isBorosilTenant && (
                  <div className="w-full">
                    <SelectComponent
                      title="Earning Type"
                      selected={earningType}
                      setSelected={setEarningType}
                      dataArr={productEarningType}
                    />
                  </div>  
                )} */}

              </div>

              <div className="w-full flex justify-start items-end space-x-2">
                  <div className="mb-6 w-1/4">
                    <InputComponent
                      name={"Product MRP (Max Retail Price)"}
                      type={"text"}
                      value={mrp}
                      setValue={setMrp}
                      required={true}
                      maxLength={8}
                    />
                  </div> 
                  <div className="mb-6 w-1/4">
                    <InputComponent
                      name={"Product WSP (Wholesale Price)"}
                      type={"text"}
                      value={wsp}
                      setValue={setWsp}
                      required={false}
                      maxLength={8}
                    />
                  </div> 
                  <div className="mb-6 w-1/4">
                    <InputComponent
                      name={"Product BSP (Base Selling Price)"}
                      type={"text"}
                      value={bsp}
                      setValue={setBsp}
                      required={false}
                      maxLength={8}
                    />
                  </div>                  
                </div>
              <div className="w-full flex justify-center ">
                <div className="mb-6 w-full">
                  <InputComponent
                    name={"Product Description"}
                    type={"textarea"}
                    value={productDes}
                    setValue={setProductDes}
                    required={true}
                    maxLength={10000}
                  />
                </div>
              </div>

              <div className="w-full flex justify-center ">
                <div className="flex items-center justify-center w-full">
                  <label
                    for="dropzone-file"
                    className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50   hover:bg-gray-100  "
                  >
                    <div className="flex flex-col items-center justify-center">
                      <svg
                        aria-hidden="true"
                        className="w-20 h-20 mb-2 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          strokeLinejoin="round"
                          stroke-width="2"
                          d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                        ></path>
                      </svg>
                      <p className="mb-2 text-sm text-gray-500">
                        <span className="font-semibold">Click to upload</span>{" "}
                        or drag and drop
                      </p>
                      <p className="text-xs text-gray-500">
                        PNG or JPG (800x400px) . Max Upto 3 Images
                      </p>
                    </div>
                    <input
                      id="dropzone-file"
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={(e) => previewImage(e)}
                    />
                  </label>
                </div>
              </div>
              {images && (
                <span className="w-10 h-10 d-block m-auto border rounded-md p-3">
                  <img
                    src={images}
                    alt=""
                    srcset=""
                    className="img-fluid flex items-center justify-center w-48 m-auto "
                  />
                </span>
              )}
            </div>
            <div className="flex justify-center mt-4 gap-4">
              <button
                type="submit"
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                onClick={handleEditProduct}
              >
                Update
              </button>
              {isVoxTenant && (
                <button
                  type="button"
                  className="text-white bg-green-600 hover:bg-green-700 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                  onClick={handleOpenPrinterSettings}
                >
                  Edit Print Settings
                </button>
              )}
            </div>
          </form>
        </div>
      </div>

      {showPrinterModal && (
        <ModalComponent size={"xl"} data={null} show={showPrinterModal} setShow={setShowPrinterModal}>
          <div className="w-full p-6 h-[80vh] overflow-y-auto">
            <h2 className="text-xl font-bold mb-4">Edit Printer Settings for {product.product_code}</h2>
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                {/* Template Type & Batch */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Template Type</label>
                  <select className="w-full border rounded p-2 text-sm" value={printerSettings.templateType} onChange={(e) => setPrinterSettings({ ...printerSettings, templateType: e.target.value })}>
                    <option value="vox_label.prn">Vox Label (vox_label.prn)</option>
                    <option value="linerio_label.prn">Linerio Label (linerio_label.prn)</option>
                    <option value="volos_label.prn">Volos Label (volos_label.prn)</option>
                    <option value="volos_label_standing.prn">Volos Label Standing (volos_label_standing.prn)</option>
                    <option value="spc_flooring_primerra.prn">SPC Flooring (spc_flooring_primerra.prn)</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Batch Code / Number</label>
                  <input type="text" className="w-full border rounded p-2 text-sm" placeholder="e.g. VOX99" value={printerSettings.batchNo} onChange={(e) => setPrinterSettings({ ...printerSettings, batchNo: e.target.value })} />
                </div>
              </div>

              {printerSettings.templateType === "linerio_label.prn" ? (
                /* ── Fields for linerio_label.prn ── */
                <>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Product Name</label>
                    <input type="text" className="w-full border rounded p-2 text-sm" placeholder="e.g. SP LINERIO M-LINE NATURAL"
                      value={printerSettings.linProductName || ''}
                      onChange={(e) => setPrinterSettings({ ...printerSettings, linProductName: e.target.value })} />
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Product Code</label>
                      <input type="text" className="w-full border rounded p-2 text-sm" placeholder="e.g. 3031362"
                        value={printerSettings.linProductCode || ''}
                        onChange={(e) => setPrinterSettings({ ...printerSettings, linProductCode: e.target.value })} />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">MRP (₹ / box)</label>
                      <input type="number" step="0.01" className="w-full border rounded p-2 text-sm" placeholder="e.g. 18392.27"
                        value={printerSettings.linMrp || ''}
                        onChange={(e) => setPrinterSettings({ ...printerSettings, linMrp: e.target.value })} />
                    </div>
                  </div>
                  <div className="grid grid-cols-3 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">OPR (Qty/Box)</label>
                      <input type="text" className="w-full border rounded p-2 text-sm" placeholder="e.g. 01"
                        value={printerSettings.linOpr || ''}
                        onChange={(e) => setPrinterSettings({ ...printerSettings, linOpr: e.target.value })} />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Q Code (number only)</label>
                      <input type="text" className="w-full border rounded p-2 text-sm" placeholder="e.g. 17"
                        value={printerSettings.linQ || ''}
                        onChange={(e) => setPrinterSettings({ ...printerSettings, linQ: e.target.value })} />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Packer (number only)</label>
                      <input type="text" className="w-full border rounded p-2 text-sm" placeholder="e.g. 10"
                        value={printerSettings.linPacker || ''}
                        onChange={(e) => setPrinterSettings({ ...printerSettings, linPacker: e.target.value })} />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Size (mm)</label>
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <input type="number" className="w-full border rounded p-2 text-sm" placeholder="length e.g. 3050"
                          value={printerSettings.linSizeWidth || ''}
                          onChange={(e) => setPrinterSettings({ ...printerSettings, linSizeWidth: e.target.value })} />
                      </div>
                      <div>
                        <input type="number" className="w-full border rounded p-2 text-sm" placeholder="width e.g. 122"
                          value={printerSettings.linSizeHeight || ''}
                          onChange={(e) => setPrinterSettings({ ...printerSettings, linSizeHeight: e.target.value })} />
                      </div>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Coverage (/box)</label>
                      <input type="number" step="0.01" className="w-full border rounded p-2 text-sm" placeholder="e.g. 64.08"
                        value={printerSettings.linCoverage || ''}
                        onChange={(e) => setPrinterSettings({ ...printerSettings, linCoverage: e.target.value })} />
                      <div className="flex gap-3 mt-1 flex-wrap">
                        {['m', 'm²', 'Sqft', 'Rft'].map((unit) => (
                          <label key={unit} className="flex items-center gap-1 text-xs font-medium text-gray-600 cursor-pointer select-none">
                            <input
                              type="checkbox"
                              className="accent-blue-600"
                              checked={printerSettings.linCoverageUnit === unit}
                              onChange={() => setPrinterSettings({ ...printerSettings, linCoverageUnit: unit })}
                            />
                            {unit}
                          </label>
                        ))}
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Pieces (pcs/box)</label>
                      <input type="number" className="w-full border rounded p-2 text-sm" placeholder="e.g. 16"
                        value={printerSettings.linPieces || ''}
                        onChange={(e) => setPrinterSettings({ ...printerSettings, linPieces: e.target.value })} />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Net Weight (kg)</label>
                      <input type="number" step="0.01" className="w-full border rounded p-2 text-sm" placeholder="e.g. 26.20"
                        value={printerSettings.linNetWeight || ''}
                        onChange={(e) => setPrinterSettings({ ...printerSettings, linNetWeight: e.target.value })} />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Gross Weight (kg)</label>
                      <input type="number" step="0.01" className="w-full border rounded p-2 text-sm" placeholder="e.g. 27.70"
                        value={printerSettings.linGrossWeight || ''}
                        onChange={(e) => setPrinterSettings({ ...printerSettings, linGrossWeight: e.target.value })} />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Barcode Number</label>
                    <input type="text" className="w-full border rounded p-2 text-sm" placeholder="e.g. 5905952337738"
                      value={printerSettings.linBarcode || ''}
                      onChange={(e) => setPrinterSettings({ ...printerSettings, linBarcode: e.target.value })} />
                  </div>
                </>
              ) : (printerSettings.templateType === "volos_label.prn" || printerSettings.templateType === "volos_label_standing.prn" || printerSettings.templateType === "spc_flooring_primerra.prn") ? (
                <>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Nominal Qty</label>
                    <input type="number" className="w-full border rounded p-2 text-sm" placeholder="e.g. 10"
                      value={printerSettings.nominalQty || ''}
                      onChange={(e) => setPrinterSettings({ ...printerSettings, nominalQty: e.target.value })} />
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Nominal Width (Mtrs)</label>
                      <input type="number" step="0.01" className="w-full border rounded p-2 text-sm" placeholder="Width"
                        value={printerSettings.nominalWidth || ''}
                        onChange={(e) => setPrinterSettings({ ...printerSettings, nominalWidth: e.target.value })} />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Nominal Height (Mtrs)</label>
                      <input type="number" step="0.01" className="w-full border rounded p-2 text-sm" placeholder="Height"
                        value={printerSettings.nominalHeight || ''}
                        onChange={(e) => setPrinterSettings({ ...printerSettings, nominalHeight: e.target.value })} />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Net Weight</label>
                      <input type="number" step="0.01" className="w-full border rounded p-2 text-sm" placeholder="Net Weight"
                        value={printerSettings.netWeight || ''}
                        onChange={(e) => setPrinterSettings({ ...printerSettings, netWeight: e.target.value })} />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Gross Weight</label>
                      <input type="number" step="0.01" className="w-full border rounded p-2 text-sm" placeholder="Gross Weight"
                        value={printerSettings.grossWeight || ''}
                        onChange={(e) => setPrinterSettings({ ...printerSettings, grossWeight: e.target.value })} />
                    </div>
                  </div>
                </>
              ) : printerSettings.templateType === "vox_label.prn" ? (
                /* ── Fields for vox_label.prn ── */
                <>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Product Code</label>
                      <input type="text" className="w-full border rounded p-2 text-sm" placeholder="e.g. 3031612"
                        value={printerSettings.productCode || ''}
                        onChange={(e) => setPrinterSettings({ ...printerSettings, productCode: e.target.value })} />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Color</label>
                      <input type="text" className="w-full border rounded p-2 text-sm" placeholder="e.g. Balance Oak"
                        value={printerSettings.productColor || ''}
                        onChange={(e) => setPrinterSettings({ ...printerSettings, productColor: e.target.value })} />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Product Category Name</label>
                      <input type="text" className="w-full border rounded p-2 text-sm" placeholder="e.g. SVP-22"
                        value={printerSettings.productCategoryName || ''}
                        onChange={(e) => setPrinterSettings({ ...printerSettings, productCategoryName: e.target.value })} />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Sub-Category Name</label>
                      <input type="text" className="w-full border rounded p-2 text-sm" placeholder="e.g. Welo SVP-22"
                        value={printerSettings.categoryName || ''}
                        onChange={(e) => setPrinterSettings({ ...printerSettings, categoryName: e.target.value })} />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Barcode</label>
                    <input type="text" className="w-full border rounded p-2 text-sm" placeholder="e.g. 590595217222"
                      value={printerSettings.barcodeNumber || ''}
                      onChange={(e) => setPrinterSettings({ ...printerSettings, barcodeNumber: e.target.value })} />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">MRP (Rs.)</label>
                    <input type="number" step="0.01" className="w-full border rounded p-2 text-sm" placeholder="e.g. 167.00"
                      value={printerSettings.mrp || ''}
                      onChange={(e) => setPrinterSettings({ ...printerSettings, mrp: e.target.value })} />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Number of Pieces</label>
                    <input type="text" className="w-full border rounded p-2 text-sm" placeholder="e.g. 10 NOS"
                      value={printerSettings.pieces || ''}
                      onChange={(e) => setPrinterSettings({ ...printerSettings, pieces: e.target.value })} />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Area in Sqm or m</label>
                    <div className="flex items-center gap-2">
                      <input type="number" step="0.01" className="flex-1 border rounded p-2 text-sm"
                        placeholder="Area in Sqm or m"
                        value={printerSettings.rft || ''}
                        onChange={(e) => setPrinterSettings({ ...printerSettings, rft: e.target.value })} />
                      <label className="flex items-center gap-1 text-sm font-medium text-gray-700 cursor-pointer select-none">
                        <input type="checkbox" checked={printerSettings.rftUnit === 'sqm'}
                          onChange={() => setPrinterSettings({ ...printerSettings, rftUnit: 'sqm' })} className="accent-blue-600" />
                        Sqm
                      </label>
                      <label className="flex items-center gap-1 text-sm font-medium text-gray-700 cursor-pointer select-none">
                        <input type="checkbox" checked={printerSettings.rftUnit === 'meter'}
                          onChange={() => setPrinterSettings({ ...printerSettings, rftUnit: 'meter' })} className="accent-blue-600" />
                        Meter
                      </label>
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Area in Rft or Sft</label>
                    <div className="flex items-center gap-2">
                      <input type="number" step="0.01" className="flex-1 border rounded p-2 text-sm"
                        placeholder="Area in Rft or Sft"
                        value={printerSettings.lengthVal || ''}
                        onChange={(e) => setPrinterSettings({ ...printerSettings, lengthVal: e.target.value })} />
                      <label className="flex items-center gap-1 text-sm font-medium text-gray-700 cursor-pointer select-none">
                        <input type="checkbox" checked={printerSettings.lengthUnit === 'rft'}
                          onChange={() => setPrinterSettings({ ...printerSettings, lengthUnit: 'rft' })} className="accent-blue-600" />
                        Rft
                      </label>
                      <label className="flex items-center gap-1 text-sm font-medium text-gray-700 cursor-pointer select-none">
                        <input type="checkbox" checked={printerSettings.lengthUnit === 'sft'}
                          onChange={() => setPrinterSettings({ ...printerSettings, lengthUnit: 'sft' })} className="accent-blue-600" />
                        Sft
                      </label>
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Length</label>
                    <input type="number" step="0.01" className="w-full border rounded p-2 text-sm" placeholder="e.g. 3.05"
                      value={printerSettings.length || ''}
                      onChange={(e) => setPrinterSettings({ ...printerSettings, length: e.target.value })} />
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Net Weight (Kg)</label>
                      <input type="number" step="0.01" className="w-full border rounded p-2 text-sm" placeholder="e.g. 4.22"
                        value={printerSettings.netWeight || ''}
                        onChange={(e) => setPrinterSettings({ ...printerSettings, netWeight: e.target.value })} />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Gross Weight (Kg)</label>
                      <input type="number" step="0.01" className="w-full border rounded p-2 text-sm" placeholder="e.g. 4.37"
                        value={printerSettings.grossWeight || ''}
                        onChange={(e) => setPrinterSettings({ ...printerSettings, grossWeight: e.target.value })} />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Q Code</label>
                      <input type="text" className="w-full border rounded p-2 text-sm" placeholder="e.g. Q:08"
                        value={printerSettings.qCode || ''}
                        onChange={(e) => setPrinterSettings({ ...printerSettings, qCode: e.target.value })} />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Packer Code</label>
                      <input type="text" className="w-full border rounded p-2 text-sm" placeholder="e.g. Packer:09"
                        value={printerSettings.packerCode || ''}
                        onChange={(e) => setPrinterSettings({ ...printerSettings, packerCode: e.target.value })} />
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Number of Pieces</label>
                    <input type="number" className="w-full border rounded p-2 text-sm" placeholder="e.g. 10"
                      value={printerSettings.pieces || ''}
                      onChange={(e) => setPrinterSettings({ ...printerSettings, pieces: e.target.value })} />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Length (Meters)</label>
                    <input type="number" step="0.01" className="w-full border rounded p-2 text-sm" placeholder="e.g. 30.50"
                      value={printerSettings.lengthVal || ''}
                      onChange={(e) => {
                        const meters = parseFloat(e.target.value) || 0;
                        const feet = (meters * 3.28084).toFixed(3);
                        setPrinterSettings({ ...printerSettings, lengthVal: e.target.value, rft: feet });
                      }} />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Q Code</label>
                    <input type="text" className="w-full border rounded p-2 text-sm" placeholder="e.g. Q:08"
                      value={printerSettings.qCode || ''}
                      onChange={(e) => setPrinterSettings({ ...printerSettings, qCode: e.target.value })} />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Packer Code</label>
                    <input type="text" className="w-full border rounded p-2 text-sm" placeholder="e.g. Packer:09"
                      value={printerSettings.packerCode || ''}
                      onChange={(e) => setPrinterSettings({ ...printerSettings, packerCode: e.target.value })} />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Barcode</label>
                    <input type="text" className="w-full border rounded p-2 text-sm" placeholder="e.g. 590595217222"
                      value={printerSettings.barcodeNumber || ''}
                      onChange={(e) => setPrinterSettings({ ...printerSettings, barcodeNumber: e.target.value })} />
                  </div>
                </>
              )}
            </div>

            <div className="flex justify-end gap-2 mt-8">
              <button
                className="bg-gray-500 hover:bg-gray-400 rounded-sm text-white font-bold py-2 px-4"
                onClick={() => setShowPrinterModal(false)}
              >
                Cancel
              </button>
              <button
                className="bg-blue-600 hover:bg-blue-500 rounded-sm text-white font-bold py-2 px-4"
                onClick={handleSavePrinterSettings}
                disabled={isUpdatingPrinterSettings}
              >
                {isUpdatingPrinterSettings ? "Saving..." : "Save Settings"}
              </button>
            </div>
          </div>
        </ModalComponent>
      )}

    </div>
  );
};

export default EditProduct;
